import { useDesignMaxTheme } from "@/packages";
import { Box } from "@chakra-ui/react";

export const BackBanner = ({ imgUrl }: { imgUrl?: string }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    return (
        <Box position="relative" w="100%">
            <Box
                w="100%"
                h={isMobile ? "224px" : "480px"}
                bg={imgUrl ? `url(${imgUrl})center center / cover no-repeat fixed` : "gray.100"}
            />
        </Box>
    );
};
